import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatErr, fmtDateTime } from "@/lib/api";

export function ReviewsAdmin() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/asv/admin/reviews").then((r) => setRows(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const act = (r, action) => {
    const reason = action === "hide" ? window.prompt("Reason for hiding this review?") : "";
    if (action === "hide" && !reason) return;
    api.post(`/asv/admin/reviews/${r.id}/${action}`, { reason }).then(() => { toast.success("Done"); load(); }).catch((e) => toast.error(formatErr(e)));
  };
  if (!rows) return null;
  return (
    <div className="card-surface space-y-3 p-5" data-testid="reviews-admin">
      <p className="font-semibold text-white">Reviews ({rows.filter((r) => r.reported).length} reported)</p>
      {!rows.length && <p className="text-sm text-slate-500">No reviews yet.</p>}
      {rows.map((r) => (
        <div key={r.id} className={`rounded-xl border p-3 text-sm text-slate-300 ${r.reported ? "border-amber-500/50" : "border-slate-800"}`} data-testid={`mod-review-${r.id}`}>
          <div className="flex flex-wrap items-center gap-2"><b className="text-white">{r.stars}★ {r.player_name}</b><span className="text-xs text-slate-500">{r.player_email} · {r.pitch_name} · {r.vendor_name} · {fmtDateTime(r.created_at)}</span>
            {r.hidden && <span className="rounded-full bg-rose-500/15 px-2 text-xs text-rose-300">Hidden: {r.hidden_reason}</span>}</div>
          {r.comment && <p className="mt-1">{r.comment}</p>}
          {r.reported && <p className="mt-1 text-xs text-amber-300">Reported by vendor: {r.report_reason}</p>}
          <div className="mt-2 flex gap-2">
            {r.hidden ? <Button size="sm" variant="outline" onClick={() => act(r, "restore")} data-testid={`mod-restore-${r.id}`}>Restore</Button> : <Button size="sm" variant="outline" onClick={() => act(r, "hide")} data-testid={`mod-hide-${r.id}`}>Hide</Button>}
            {r.reported && <Button size="sm" variant="ghost" onClick={() => act(r, "dismiss")} data-testid={`mod-dismiss-${r.id}`}>Dismiss report</Button>}
          </div>
        </div>))}
    </div>
  );
}
